import { axiosBase, errorHandler } from "./axios";

const userLogin = (input: any) => {
  return axiosBase.post("/api/v1/account/login", input)
      .then((response) => response.data)
      .catch((error) => errorHandler(error));
  };
const userLogout = (input: any) => {
  return axiosBase.post("/api/v1/account/logout", {deviceId:input})
      .then((response) => response.data)
      .catch((error) => errorHandler(error));
  };

const verifyOtp = (input:any) =>{
    return axiosBase.post('/api/v1/account/verify-Otp',input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const verifyInvite = (token:string)=>{
    return axiosBase.post('/api/v1/account/verifyLink',{token})
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const userResendInvite = (input:any)=>{
    return axiosBase.post('/api/v1/users/resendInvitation',input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const sendOtp = (input: any) => {
    return axiosBase.post('/api/v1/account/send-otp', input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const resendOtp = (input: any) => {
    return axiosBase.post('/api/v1/account/resend-otp', input)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

export const authService = {
    userLogin,
    userLogout,
    verifyOtp,
    verifyInvite,
    userResendInvite,
    sendOtp,
    resendOtp
}